// extracted by mini-css-extract-plugin
export default {"root":"SearchOption__root--ldueH"};